import { useTranslations } from '~/services/umbraco/hooks';
import { SkeletonLoader } from '~/shared/components/SkeletonLoader';
import { CategoryList, CategoryListItem, Link } from './styled';

type Props = {
    activeCategory: string;
    categories: string[];
    setBrandCategory: (category: string) => void;
    isLoading: boolean;
};

export default function CategoryFilter({
    categories,
    activeCategory,
    setBrandCategory,
    isLoading,
}: Props) {
    const { translate } = useTranslations();

    if (isLoading || !categories) {
        return <Skeleton />;
    }

    return (
        <CategoryList>
            <CategoryListItem>
                <Link
                    isActive={!activeCategory}
                    onClick={() => setBrandCategory('')}
                    fullWidth
                    multipleElements
                >
                    {translate('brands.allBrands')}
                </Link>
            </CategoryListItem>

            {categories.map((category, id) => (
                <CategoryListItem key={id}>
                    <Link
                        isActive={activeCategory === category}
                        onClick={() => setBrandCategory(category)}
                        fullWidth
                        multipleElements
                    >
                        {category}
                    </Link>
                </CategoryListItem>
            ))}
        </CategoryList>
    );
}

function Skeleton() {
    return (
        <CategoryList>
            {Array.from({ length: 5 }).map((_, index) => (
                <CategoryListItem key={index}>
                    <SkeletonLoader width={80} height={22} />
                </CategoryListItem>
            ))}
        </CategoryList>
    );
}
